import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { useSelector } from 'react-redux';
import ScreenA from '../screens/play/ScreenA';
import ScreenB from "../screens/play/ScreenB";
import UITest from "../screens/play/UITest";

const playStack = createStackNavigator()

const verticalAnimation = {
  headerShown: false,
  // header: (props) => <Header {...props} />,
  presentation: 'modal',
  gestureEnabled: true,
  gestureDirection: 'vertical',
  cardStyleInterpolator: ({ current, layouts }) => {
    // console.log("vertival")
    return {
      cardStyle: {
        transform: [
          {
            translateY: current.progress.interpolate({
              inputRange: [0, 1],
              outputRange: [layouts.screen.height, 0],
            }),
          },
        ],
      },
    }
  },
}

export default function Playground({ navigation }) {
  const user = useSelector((state) => state.user)

  return (
    <playStack.Navigator initialRouteName='UITest' screenOptions={verticalAnimation}>
      <playStack.Screen name='ScreenA' component={ScreenA} options={{ headerShown: false }} />
      <playStack.Screen name='ScreenB' component={ScreenB} options={{ headerShown: false }} />
      <playStack.Screen name='UITest' component={UITest} options={{ headerShown: false }} />
    </playStack.Navigator>
  )
}